import React from 'react';
import { connect } from 'react-redux';
import { Box, Snackbar, Alert, Typography } from '@mui/material';

import Products from '../../../components/GenericProductConfig/components/Products/AllProducts';
import SkeletonWrapper from '../../NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import {
  getOrgProductTemplatesRequest,
  createOrgProductTemplateRequest,
  resetCreateOrgProductTemplateSuccess,
  resetCreateOrgProductTemplateError,
} from '../../OrganizationProductTemplates/Redux/actions';

class ProductTemplatesTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      snackbarOpen: false,
      snackbarMessage: '',
      snackbarSeverity: 'success',
    };
  }

  componentWillMount() {
    this.props.dispatch(
      getOrgProductTemplatesRequest(this.props.organizationGuid)
    );
  }

  componentDidUpdate(prevProps) {
    var d = this.props.orgProductTemplates;
    var p = prevProps.orgProductTemplates;

    if (d.created && !p.created) {
      this.openSnack('Product template created successfully', 'success');
      this.props.dispatch(resetCreateOrgProductTemplateSuccess());
    }
    if (d.createError && !p.createError) {
      this.openSnack('Failed to create template: ' + String(d.createError), 'error');
      this.props.dispatch(resetCreateOrgProductTemplateError());
    }
  }

  openSnack(message, severity) {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  }

  handleCreateTemplate(formData) {
    // All fields from <ProductForm> (name, code, type, cover_type,
    // lapse_period_*, cool_off_*, debit_grace_days, grace_period_*,
    // policy_number_prefix, reinstatement) are preserved inside product_data.
    var product_data = Object.assign({}, formData);

    this.props.dispatch(createOrgProductTemplateRequest({
      organization_guid: this.props.organizationGuid,
      code: formData.code,
      name: formData.name,
      product_data: product_data,
      active: true,
    }));
  }

  render() {
    var d = this.props.orgProductTemplates;
    var state = this.state;

    if (d.loading) return <SkeletonWrapper loading={true} />;

    var list = d.list || [];

    // Adapt each template to the shape <Products> card expects:
    // spread product_data fields so the card can display type, cover_type, etc.
    // then overlay top-level guid/code/name/active.
    var cards = list.map(function(t) {
      var pd = t.product_data || {};
      return Object.assign({}, pd, {
        guid: t.guid,
        code: t.code,
        name: t.name,
        active: t.active,
      });
    });

    return (
      <Box>
        <Box sx={{ mb: 2.5 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 18, color: '#111827' }}>
            Product Templates
          </Typography>
          <Typography sx={{ fontSize: 13, color: '#6B7280', mt: 0.25 }}>
            Reusable product definitions per organization.
          </Typography>
        </Box>

        <Products
          products={cards}
          onProductInfoSubmit={this.handleCreateTemplate.bind(this)}
          isLoading={d.creating}
        />

        <Snackbar
          open={state.snackbarOpen}
          autoHideDuration={4000}
          onClose={() => this.setState({ snackbarOpen: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            severity={state.snackbarSeverity}
            onClose={() => this.setState({ snackbarOpen: false })}
          >
            {state.snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default connect(function(state) {
  return { orgProductTemplates: state.orgProductTemplatesData };
})(ProductTemplatesTab);
